import { PublicClientApplication, EventType, type AuthenticationResult, type Configuration } from "@azure/msal-browser";
import { useSuspenseQuery } from "@tanstack/react-query";

import client from "api/client";
import { useSettings } from "features/start/fabric";

export const useQueryMsal = () => {
	const settings = useSettings();
	return useSuspenseQuery({
		queryKey: ["msal"],
		queryFn: () => {
			const msalOptions = {
				auth: {
					clientId: settings.azureAd.clientId,
					authority: `${settings.azureAd.instance}${settings.azureAd.tenantId}`,
					redirectUri: `https://${location.host}`
				},
				cache: {
					cacheLocation: "localStorage"
				}
			} satisfies Configuration;

			const msal = new PublicClientApplication(msalOptions);
			msal.initialize()
				.then(async () => {
					const account = msal.getActiveAccount();
					if (!account && msal.getAllAccounts().length > 0) msal.setActiveAccount(msal.getAllAccounts()[0]);
					msal.enableAccountStorageEvents();
					msal.addEventCallback((event) => {
						const authenticationResult = event?.payload as AuthenticationResult;
						if (event.eventType === EventType.LOGIN_SUCCESS && authenticationResult?.account) {
							const account = authenticationResult?.account;
							msal?.setActiveAccount(account);
							window.location.reload();
						}
					});
					client.setAuthTokenProvider(async () => {
						const active = msal?.getActiveAccount() ?? msal?.getAllAccounts()[0];
						if (!active) return undefined;
						const token = await msal?.acquireTokenSilent({
							account: active,
							authority: `${settings.azureAd.instance}${settings.azureAd.tenantId}/v2.0`,
							scopes: [`${settings.azureAd.audience}/full_access`]
						});
						return token?.accessToken;
					});
				});
			return msal;
		}
	});
};